import { createFileRoute, Link } from "@tanstack/react-router";
import { Check, ShoppingBag } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { canonicalLink, pageMeta } from "@/lib/seo";

export const Route = createFileRoute("/shop/order-complete")({
  validateSearch: (search: Record<string, unknown>): { session_id?: string } => ({
    session_id: typeof search.session_id === "string" ? search.session_id : undefined,
  }),
  head: () => ({
    meta: pageMeta({
      title: "Order Complete | Texas Made Shade & Covers Shop",
      description:
        "Thank you for your order from Texas Made Shade & Covers. Your Sunbrella cleaners, adhesives, thread and canvas supplies are on the way.",
      path: "/shop/order-complete",
    }),
    links: [canonicalLink("/shop/order-complete")],
  }),
  component: OrderComplete,
});

function OrderComplete() {
  const { session_id: sessionId } = Route.useSearch();

  return (
    <div className="min-h-screen bg-cream">
      <SiteHeader />
      <main id="main-content" tabIndex={-1} className="mx-auto max-w-2xl px-5 py-20 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red text-white">
          <Check className="h-8 w-8" />
        </div>
        <h1 className="mt-6 font-display text-3xl font-bold uppercase text-navy-deep sm:text-4xl">
          Thank you — your order is in
        </h1>
        <div className="mx-auto mt-4 max-w-xl space-y-3 text-navy-deep/80">
          <p>
            Your card payment went through and a receipt is on its way to your email.
            Our office in Seguin has your order and will pack and ship it — most
            in-stock supplies leave the shop within 1–2 business days.
          </p>
          <p>
            Questions, changes or a return?{" "}
            <a href="tel:+18303909588" className="font-semibold underline">
              (830) 390-9588
            </a>{" "}
            or{" "}
            <a href="mailto:office@texasmadeshade.com" className="font-semibold underline">
              office@texasmadeshade.com
            </a>
            .
          </p>
          {sessionId && (
            <p className="text-xs text-navy-deep/70">
              Reference: {sessionId.slice(-12)}
            </p>
          )}
        </div>
        <Link
          to="/shop"
          className="mt-8 inline-flex items-center gap-2 bg-navy-deep px-6 py-3 font-display text-xs uppercase tracking-wider text-white transition hover:bg-red"
        >
          <ShoppingBag className="h-4 w-4" /> Back to the shop
        </Link>
      </main>
      <SiteFooter />
    </div>
  );
}
